module.exports = __webpack_public_path__ + "static/media/logo-evolotion-gaming.1d16ed69.svg";